import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCustomer } from '../contexts/customer-context';

const ProtectedRoute = ({ children }) => {
  const { token, expiresAt } = useCustomer();

  if (!token || new Date(expiresAt) <= new Date()) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;